var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoColor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 629.5 164.2",
    style: {
      enableBackground: "new 0 0 629.5 164.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#800000;} /* Deep maroon */\n\t.st1{fill:#999999;} /* Gray */\n\t.st3 {fill:#800000;} /* maroon */\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M126.4,53H23.9V34.6c0-7.8,6.3-14.1,14.1-14.1h102.6v18.3C140.6,46.6,134.2,53,126.4,53z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M96.6,98.3H23.9V80.2c0-7.9,6.4-14.3,14.3-14.3h72.6v18.3C110.8,92,104.4,98.3,96.6,98.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M66.3,143.7H23.9v-18.2c0-7.9,6.4-14.3,14.3-14.3H81V129C81,137.1,74.4,143.7,66.3,143.7z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "23.9,53 49.8,65.9 110.8,65.9 82.2,53  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "23.9,98.3 44.8,111.2 81,111.2 59.9,98.3  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M190.3,96.3v24.1h-18V45.9h50.2v16.4h-32.2v17.5h27.2v16.4H190.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M248.4,63.1v32.2c0,6.1,2.2,8.8,6.8,8.8c4.1,0,7-3,8.2-5.7V63.1h18.5v57.3h-18.5v-5.5 c-3.3,3.8-9.2,6.5-15.8,6.5c-12.5,0-17.7-8.3-17.7-22.2v-36H248.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M324.8,120.4V88.3c0-6.2-2.2-8.9-6.9-8.9c-4.1,0-6.9,3-8.2,5.7v35.3h-18.4V63.1h18.4v5.5 c3.3-3.8,9.3-6.5,15.8-6.5c12.5,0,17.9,8.3,17.9,22.2v36H324.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M403.2,120.4h-18.5v-4.9c-3.1,3.6-7.4,6-13.3,6c-13,0-21.8-10.5-21.8-29.8c0-19.3,8.8-29.6,21.8-29.6 c5.6,0,10.1,2.4,13.3,5.7V42.7h18.5V120.4z M377.6,105.2c2.8,0,5.6-1.5,7.1-3.2V81.8c-1.4-1.5-4.2-3.3-7.1-3.3 c-5.8,0-9.1,5-9.1,13.5C368.5,100.2,371.9,105.2,377.6,105.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M413.8,120.4V45.9h18.8v58.2h30v16.3H413.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M466.7,125.2c2.3,1.2,5.1,1.9,7.2,1.9c3.7,0,5.7-1.9,6.9-6.4l0.5-2.3l-21.1-55.3h20.5l8.7,36.8l9.2-36.7 c6.1,0,12.4-0.1,18.6-0.1l-20.5,61.1c-3.8,11.6-9.2,17.9-21.4,17.9c-4.1,0-8.4-1.5-11.2-3.1L466.7,125.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M552.8,80.2c-4.3-2.2-8.4-3.6-12.3-3.6c-3.2,0-4.5,1.4-4.5,3.7c0,1.6,1.2,2.7,4.5,3.9l4.7,1.8 c9.6,3.7,12.4,9.2,12.4,16.4c0,10.4-8.3,19.1-21.8,19.1c-8.3,0-15.9-2.3-19.6-4.3l3.4-15c3.7,2.4,9.3,4.8,13.7,4.8 c3.7,0,5.7-1.5,5.7-4.1c0-2.3-1.3-3.6-4.5-4.7l-4.9-2c-8.3-3.2-12.5-7.8-12.5-15.8c0-10.8,7.4-18.4,21.5-18.4 c6.5,0,14.7,1.8,18.6,3.6L552.8,80.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M587.6,99.3c0,4.2,1.8,6,4.9,6c2.8,0,6.5-1.5,8.7-3.2l4.4,14.5c-5.1,2.6-10.3,4.9-18.6,4.9 c-10.4,0-17.7-5.8-17.7-19.7V77.7h-7.9V63.1h9.1l2.2-14.6h15v14.6h15.9v14.6h-15.9V99.3z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoColor);
export default __webpack_public_path__ + "static/media/logo-color.1c0d72fd22c7339c576509e9d75b0022.svg";
export { ForwardRef as ReactComponent };